export default (html: string) => {
    return (
      html &&
      html
        .replace(/<[^>]*>/g, '')
        .replace('&nbsp;', '')
        .trim()
    );
  };